import { useMemo } from 'react';
import { range } from 'lodash';
import { addDays, startOfWeek } from 'date-fns';
import { useLocale } from '../../LocaleProvider';
export const useLocalizedWeekdays = () => {
    const { datePicker: locale } = useLocale();
    const { format } = useMemo(() => new Intl.DateTimeFormat(locale.dateLocale, {
        weekday: 'short',
    }), [locale.dateLocale]);
    const weekdays = useMemo(() => {
        return range(7)
            .map((index) => addDays(startOfWeek(new Date(), {
            weekStartsOn: locale.weekStartsOn,
        }), index))
            .map((date) => format(date));
    }, [format, locale.weekStartsOn]);
    return {
        weekdays,
        getDay: format,
    };
};
//# sourceMappingURL=useLocalizedWeekdays.js.map